module.exports = __webpack_public_path__ + "static/media/aurora.a744350a.svg";